module.exports = __webpack_public_path__ + "img/fi-rr-menu-burger.71c1f5a9.svg";